import { TagGroup, type TagSize } from "@fluentui/react-components";
import * as React from "react";
import type { Badge } from "../PromptBadges.types";
import { AdditionalBadges } from "./AdditionalBadges";

export type PromptBadgesGroupProps = {
  extraBadges?: Badge[];
  tagSize?: TagSize;
  children: React.ReactNode;
};

export const PromptBadgeGroup: React.FC<PromptBadgesGroupProps> = ({
  tagSize = "small",
  extraBadges,
  children,
}) => {
  return (
    <TagGroup role="list">
      {children}
      <AdditionalBadges badges={extraBadges} tagSize={tagSize} />
    </TagGroup>
  );
};
